const short = require('short-uuid');
const baseModel = require("../baseModel")
const UserInfo = require('../../appUtils/UserInfo');
const DateUtil = require('../../appUtils/DateUtil')
/**
 * 最近使用ノード用のデータ取得モデルクラス
 */
class RecentlyModel extends baseModel {
  /**
   * テナント内の最近使用ノードリストを取得する
   * @param {テナント(グループ)}} tenantId
   * @returns
   */
  static async list(projectId, userSub, tenantId = null) {
    let sk = this.createSk(projectId, userSub)

    return await super.getList({beginsWith: `${sk}`}, tenantId)
  }

  /**
   * 最近使用ノードを削除する
   * @param {pk:テナントID, sk:sk} data
   * @returns
   */
  static async delete(data) {
    await super.deleteData(data)
  }

  /**
   * 最近使用ノード管理レコードを追加する
   * @param {*} data
   */
  static async add(data){
    await super.addData(data)
  }

  /**
   * 最近使用ノード管理レコードを更新する
   * @param {*} data
   */
  static async update(data) {
    await super.updateData(data)
  }

  /**
   * 最近使用ノード管理レコードを取得する
   * @param {*} data
   */
  static async get(sk, tenantId = null){

    let treeData = await super.getSingleData({sk: sk}, tenantId);
    
    return treeData
   
  }


  /**
   * skの文字列を生成
   * @param {*}
   * @returns
   */
  static createSk(projectId, userSub, id = null){
    if (id) {
      return `recently#${projectId}#${userSub}#${id}`
    } else {
      return `recently#${projectId}#${userSub}`
    }    
  }
  
  /**
   * 新規登録用のデータ
   * @param {*} projectId 
   * @returns 
   */
  static async getNewData(projectId, userSub) {
    const id = short.generate()
    let newRowData = await super.getNewData()
    newRowData.lsiInt1 = DateUtil.getUnixTimeStampOfSecond()
    newRowData.sk = this.createSk(projectId, userSub, id)
    
    newRowData.recently = {
      
      id: `${id}`,
      targetSk: ""
    }
    return newRowData
   
  }
}

module.exports = RecentlyModel
